import React from "react";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import {RequestOverviewRowDTO} from "@/api/data-contracts";
import {RequestI18N} from "@/translations";
import {remainingValidityDays} from "@/model/request";

export interface RequestValidUntilCellProps {
    row: RequestOverviewRowDTO;
    dateFormat: string;
}

/**
 * Renders the "valid until" column cell with remaining validity days indicator.
 */
export const RequestValidUntilCell: React.FC<RequestValidUntilCellProps> = ({row, dateFormat}) => {
    const {t} = useTranslation();
    const dateLabel = row.validUntil ? dayjs(row.validUntil).format(dateFormat) : null;
    const days = remainingValidityDays(row.validUntil);

    let subText: string | null = null;
    let subColor = "warning.dark";
    let subFontWeight = 400;

    if (days !== null) {
        if (days === 0) {
            subText = t(RequestI18N.details.field.remainingValidityToday);
            subColor = "error.main";
            subFontWeight = 700;
        } else if (days === 1) {
            subText = t(RequestI18N.details.field.remainingValidityTomorrow);
            subColor = "error.main";
            subFontWeight = 600;
        } else {
            subText = t(RequestI18N.details.field.remainingValidityDays, {count: days});
        }
    }

    return (
        <>
            {dateLabel}
            {subText !== null && (
                <Typography
                    variant="body2"
                    color={subColor}
                    fontWeight={subFontWeight}
                    display="block"
                >
                    {subText}
                </Typography>
            )}
        </>
    );
};
